export const DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'total-products'
